import { getStructureGridHeaders } from './atoms';
import { atom, useAtom } from 'jotai';
import { loadable } from 'jotai/utils';

const structureGridsBaseAtom = atom(getStructureGridHeaders());

export const useStructureGrids = () => {
  const structureGridsAtom = loadable(structureGridsBaseAtom);
  const [gridState] = useAtom(structureGridsAtom);

  const isBasinsLoading = gridState.state === 'loading';

  const availableBasins =
    gridState.state === 'hasData'
      ? gridState.data?.structureGrids?.basins || []
      : [];
  const getFormationsForBasin = (basinId: string) => {
    return (
      availableBasins.find((basin) => basin.id === basinId)?.structureGrids ||
      []
    );
  };

  return {
    isBasinsLoading,
    availableBasins,
    getFormationsForBasin,
  };
};
